import GimpoWooriSite from "../../hospital/GimpoWooriSite";
import HiMedicalSite from "../../hospital/HiMedicalSite";
import NexusSite from "../../corporate/NexusSite";
import MorningBrewSite from "../../cafe/MorningBrewSite";
import SpiralRoastSite from "../../cafe/SpiralRoastSite";
import FirstBankSite from "../../bank/FirstBankSite";
import HanokdamSite from "../../restaurant/HanokdamSite";
import { useBrandContext } from "./brandContext";
import { getSiteRenderer } from "./siteRegistry";
import { THEME_LAYOUTS } from "./ThemeLayouts";

const FULL_SITES = {
  "gimpo-woori": GimpoWooriSite,
  "hi-medical": HiMedicalSite,
  nexus: NexusSite,
  brew: MorningBrewSite,
  "spiral-roast": SpiralRoastSite,
  bank: FirstBankSite,
  hanok: HanokdamSite,
};

export default function AdaptiveBrandSite({ industry, demoId, embed = false }) {
  const ctx = useBrandContext(industry, demoId);
  const renderer = getSiteRenderer(industry, demoId);
  const FullSite = FULL_SITES[renderer];

  if (FullSite) {
    const profileProps = ["hi-medical", "nexus", "brew", "bank", "hanok"].includes(renderer) && renderer !== "gimpo-woori"
      ? { profileId: demoId }
      : {};
    return <FullSite embed={embed} {...profileProps} />;
  }

  const ThemeLayout = THEME_LAYOUTS[renderer] ?? THEME_LAYOUTS.nova;
  return <ThemeLayout {...ctx} embed={embed} />;
}
